import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {InputAuthBody} from '../model/inputAuthBody';
import {AppSettings} from '../utilities/AppSettings';

@Injectable({
  providedIn: 'root'
})
export class RestConnectionService {

  constructor(private httpClient: HttpClient) {
  }

  public checkCardBalance(queryBody: InputAuthBody): Promise<any> {
    return this.httpClient.post(AppSettings.API_URL + 'Englishrest/handleInquiry', queryBody).toPromise();
  }

  public checkCardHistory(queryBody: InputAuthBody): Promise<any> {
    return this.httpClient.post(AppSettings.API_URL + 'Englishrest/handleTransactionList/', queryBody).toPromise();
  }
}
